var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9091 3.63636H1.81818V0H30.9091V3.63636ZM30 20H27.2727V29.0909L33.8364 33.0182L35.2 30.8L30 27.7273V20ZM41.8182 27.2727C41.8182 34.3091 36.1273 40 29.0909 40C22.6727 40 17.4 35.2545 16.5091 29.0909H1.81818V18.1818H0V14.5455L1.81818 5.45455H30.9091L32.7273 14.5455V15.0727C37.9818 16.6545 41.8182 21.5091 41.8182 27.2727ZM3.70909 14.5455H29.0182L27.9273 9.09091H4.8L3.70909 14.5455ZM5.45455 25.4545H16.3636V18.1818H5.45455V25.4545ZM38.1818 27.2727C38.1818 22.2545 34.1091 18.1818 29.0909 18.1818C24.0727 18.1818 20 22.2545 20 27.2727C20 32.2909 24.0727 36.3636 29.0909 36.3636C34.1091 36.3636 38.1818 32.2909 38.1818 27.2727Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a70308d0546bbdc30993d45950171f8d.svg";
export { ForwardRef as ReactComponent };